export class SelectionSearchService {  
  
    itemsList:any;
    variableType: string;
    
    country1: string;
    state1: string;
    city1: string;

    country2: string;
    state2: string;
    city2: string;

    constructor() {
        //this.initializeService();
    }
  
    setItemsList(items) {
        this.itemsList = items;
        console.log(this.itemsList);
    }
  
    getItemsList() {
        return this.itemsList;
    }   

    setVariableType(varType){
        this.variableType = varType;
    }

    getVarableType(){
        return this.variableType;
    }

    setCountry1(country){this.country1 = country;}

    setState1(state){this.state1 = state;}

    setCity1(city){this.city1 = city;}

    setCountry2(country){this.country2 = country;}

    setState2(state){this.state2 = state;}

    setCity2(city){this.city2 = city;}

    getCountry1(){return this.country1;}

    getState1(){return  this.state1;}

    getCity1(){return  this.city1;}

    getCountry2(){return this.country2;}

    getState2(){return  this.state2;}

    getCity2(){return   this.city2;}

    initializeService(){
        this.itemsList = [];
        this.variableType = "";
        this.country1="";
        this.state1="";
        this.city1 = "";
        this.country2="";
        this.state2="";
        this.city2 = "";

        console.log("SelectionService Initialized");
    }

}


// WEBPACK FOOTER //
// ./src/services/selection-search.ts